var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 3.5C9.41 3.5 6.5 6.41 6.5 10V14.2L4.9 17.4C4.57 18.07 5.05 18.85 5.8 18.85H20.2C20.95 18.85 21.43 18.07 21.1 17.4L19.5 14.2V10C19.5 6.41 16.59 3.5 13 3.5Z",
    fill: "#E3F1D9",
    stroke: "#74B743",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2 21.2C10.75 22.2 11.8 22.85 13 22.85C14.2 22.85 15.25 22.2 15.8 21.2",
    stroke: "#74B743",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.4b0498e9889c864a276f35d442671eff.svg";
export { ForwardRef as ReactComponent };